import { getCalendarByCalendarId, getCalendarEntryByCalendarId } from 'owa-calendar-cache';
import { isLocalLieCalendar } from 'owa-calendar-surface-calendars-store';
import { lazyInitializeLivePersonaCardForBirthdayEvent } from 'owa-event-context-menu';
import type { CalendarEntry } from 'owa-graph-schema';
import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import { orchestrator } from 'satcheljs';
import { showCalendarContextMenu } from '../actions/calendarActions';
import { setContextMenuViewState } from '../mutators/contextMenuMutators';

orchestrator(showCalendarContextMenu, async actionMessage => {
    const { scenarioId, calendarId, anchorElement } = actionMessage;

    const calendar = getCalendarByCalendarId(calendarId);
    if (calendarId && (!calendar || !isLocalLieCalendar(calendar))) {
        setContextMenuViewState(scenarioId, calendarId, anchorElement);

        const calendarEntry: CalendarEntry = getCalendarEntryByCalendarId(calendarId);
        if (
            calendarEntry &&
            calendarEntry.CalendarFolderType == CalendarFolderTypeEnum.BirthdayCalendar
        ) {
            await lazyInitializeLivePersonaCardForBirthdayEvent.importAndExecute();
        }
    }
});
